/**
 * @license
 * Copyright (c) Peculiar Ventures, LLC.
 *
 * This source code is licensed under the BSD 3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { FunctionalComponent, h } from '@stencil/core';
import { FortifyStatus } from '../fortify-status';

export const FortifyConnecting: FunctionalComponent = () => (
  <FortifyStatus
    title=""
    description=""
  >
    <peculiar-circular-progress />
  </FortifyStatus>
);
